import { ProfileField } from "../../../types/ProfileField"
import i18n from "@service/locale/i18";

const getCaption = (field: ProfileField, language: string) => {
    return field && field.title && field.title[language]
        ? field.title[language]
        : i18n.t('settings.' + field.name.toLowerCase()).toString();
}

export const getHeaderSettingsByFields = (fields: ProfileField[], language: string) => {
    return fields
        .filter(field => field.type !== "tag")
        .map((field, index) => {
        return {
            title: getCaption(field, language),
            name: field.name,
            ...(index === 0 ? { tooltipText: "" } : null)
        }
    })
}